"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logNotValidUrlGenerator = exports.NOT_VALID_URL = void 0;
const core_1 = require("../../core");
exports.NOT_VALID_URL = 'Not Valid URL';
const logNotValidUrlGenerator = (method) => (args) => {
    try {
        const urlRaw = method(args);
        new URL(urlRaw);
        return urlRaw;
    }
    catch (e) {
        core_1.Log.warn('[logNotValidUrlGenerator] - Not valid url generated - Review generator implementation');
        throw new Error(exports.NOT_VALID_URL);
    }
};
exports.logNotValidUrlGenerator = logNotValidUrlGenerator;
//# sourceMappingURL=utils.js.map